import {
  blackColor,
  whiteColor,
  hexToRgb
} from "assets/jss/style.js";

const cardStyle = {
  card: {
    border: "0",
    margin: "25px 0 0",
    //marginBottom: "30px",
    // marginTop: "30px",
    borderRadius: "6px",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.87)",
    background: whiteColor,
    boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem",
    width: "inherit !important"},
  cardInfo: {
    width: "230px",
    marginRight: "25px"
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardProfile: {
    color: whiteColor,
    background: "#042f41 !important ",
    // backgroundImage: `url(${fondo}) !important`,
    backgroundPositionX: "right  !important",
    backgroundPositionY: "bottom !important",
    backgroundSize: "50% !important",
    backgroundRepeat: "repeat-x",
    marginTop: "30px",
    textAlign: "center",
    boxShadow:
      "0 16px 38px -12px rgba(" +
      hexToRgb(blackColor) +
      ", 0.56), 0 4px 25px 0px rgba(" +
      hexToRgb(blackColor) +
      ", 0.12), 0 8px 10px -5px rgba(" +
      hexToRgb(blackColor) +
      ", 0.2)",
    "&$cardAvatarPlain": {
      marginTop: "0"
    }
  },
  cardChart: {
    "& p": {
      marginTop: "0px",
      paddingTop: "0px"
    }
  }
};

export default cardStyle;
